import DataHexagon from '@backrs_ui/common-ui/src/assets/images/data-hexagon.svg';

import { Card, CardContent, Box, SxProps, Theme, Typography, Checkbox } from '@mui/material';

export type DataLockedAndLoadedCardProps = Readonly<{
  title: string;
  description: string;
  checkboxItems: string[];
}>;

export function DataLockedAndLoadedCard({
  title,
  description,
  checkboxItems = [],
}: DataLockedAndLoadedCardProps) {
  return (
    <Card sx={cardContainer}>
      <Box sx={cardTopSx}>
        <Box sx={headerImageSx}>
          <img src={DataHexagon} alt="Header" />
        </Box>
      </Box>
      <CardContent sx={contentContainer}>
        <Box sx={cardTitleContainer}>
          <Typography variant="text-lg-semibold">{title}</Typography>
          <Typography variant="text-sm-regular">{description}</Typography>
        </Box>
        <Box sx={checkboxContainer}>
          {checkboxItems.map((item: string) => (
            <Box key={item} sx={checkboxItemContainer}>
              <Checkbox sx={checkBoxSx} defaultChecked disabled />
              <Typography
                variant="text-xs-regular"
                color={(theme) => theme.backrs.colors['Colors/Base/Black']}
              >
                {item}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

const checkBoxSx: SxProps<Theme> = ({ backrs }) => ({
  '&.Mui-checked .MuiSvgIcon-root': {
    color: backrs.colors['Brand/500'],
    outline: `1px solid ${backrs.colors['Colors/Base/Black']}`,
    outlineOffset: '-4px',
    borderRadius: backrs.spacing['spacing-sm'],
  },
  paddingTop: 0,
  marginTop: 0,
});

const checkboxItemContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
};

const checkboxContainer: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-lg'],
});

const cardContainer: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',

  minWidth: {
    xs: '100%',
    md: `calc(50% - ${backrs.spacing['spacing-4xl']})`,
  },
  maxWidth: {
    xs: '100%',
    md: `calc(50% - ${backrs.spacing['spacing-4xl']})`,
  },
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  background: backrs.colors['Colors/Background/bg-primary'],
});

const contentContainer: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  padding: `${backrs.spacing['spacing-3xl']} ${backrs.spacing['spacing-3xl']} ${backrs.spacing['spacing-3xl']}`,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-xl'],
});

const cardTopSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  bgcolor: backrs.colors['OrangeDark/500'],
});

const cardTitleContainer: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-xs'],
});

const headerImageSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: backrs.spacing['spacing-lg'],
});
